export type FreshnessState = "fresh" | "stale" | "unknown";

const FRESH_MS = 60 * 60 * 1000;

export function computeFreshness(
  generatedAt: string | null | undefined,
  now: number = Date.now(),
): FreshnessState {
  if (!generatedAt) return "unknown";
  const age = now - new Date(generatedAt).getTime();
  if (age < FRESH_MS) return "fresh";
  return "stale";
}
